import React, { useState, useRef, useEffect } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CheckIcon from "@mui/icons-material/Check";
import { connect } from "react-redux";
import CustomTooltip from "../customComponent/CustomTooltip";

import speedImg from "@/_images/speedicons/ActiveSpeed_Icon.svg";
import accelerationImg from "@/_images/speedicons/AccelControl_Icon.svg";
import tamperImg from "@/_images/speedicons/Tamper_Icon.svg";
import displayImg from "@/_images/speedicons/DigiDisplay_Icon.svg";
import overrideImg from "@/_images/speedicons/Override_Icon.svg";
import centerImg from "@/_images/speedicons/DeviceAndLines.svg";
import centerImgMobile from "@/_images/speedicons/DeviceAndLines_Mobile.svg";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import ContinueButton from "./ContinueButton";
import Grid from "@mui/material/Grid";

const LearnMore = ({ setActiveStep, submitting, handleUpdate }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.down("lg"));
  const isOpenCloseBtn = useMediaQuery(theme.breakpoints.down(1281));
  const [openFeature, setOpenFeature] = useState(null);
  const [pausedFeature, setPausedFeature] = useState(null);
  // const [reviewedFeatures, setReviewedFeatures] = useState([]);
  const [reviewedFeatures, setReviewedFeatures] = useState(() => {
    const stored = localStorage.getItem("reviewedFeatures");
      return stored ? JSON.parse(stored) : [];
  });

  const iconRefs = useRef({});
  const [tooltipPos, setTooltipPos] = useState({ top: 0, left: 0 });
  const { t } = useTranslation();

  let features = [
    {
      key: "speed",
      title: t("speed.activeSpeedControl"),
      desc: t("speed.activeSpeedControlDescription"),
      img: speedImg,
      position: { top: "28%", left: "18%" },
      size: { width: 128, height: 102.4 },
      mobilePos: { top: "24%", left: "14%" },
      mobileSize: { width: 120, height: 80 },
      isMobileReverse: 1,
    },
    {
      key: "acceleration",
      title: t("speed.accelerationControl"),
      desc: t("speed.accelerationControlDescription"),
      img: accelerationImg,
      position: { top: "27%", right: "-5%" },
      size: { width: 152, height: 102.4 },
      mobilePos: { top: "26%", right: "-20%" },
      mobileSize: { width: 130, height: 80 },
      isMobileReverse: 3,
    },
    {
      key: "tamper",
      title: t("speed.tamperDetection"),
      desc: t("speed.tamperDetectionDescription"),
      img: tamperImg,
      position: { bottom: "-4%", left: "28%" },
      size: { width: 128, height: 105.6 },
      mobilePos: { bottom: "-10%", left: "30%" },
      mobileSize: { width: 110, height: 90 },
      isMobileReverse: 4,
    },
    {
      key: "display",
      title: t("speed.digitalDisplays"),
      desc: t("speed.digitalDisplaysDescription"),
      img: displayImg,
      position: { top: "13%", left: "49%" },
      size: { width: 136, height: 112 },
      mobilePos: { top: "-3%", left: "50%" },
      mobileSize: { width: 120, height: 100 },
      isMobileReverse: 5,
    },
    {
      key: "override",
      title: t("speed.temporaryOverride"),
      desc: t("speed.temporaryOverrideDescription"),
      img: overrideImg,
      position: { bottom: "8%", right: "2.8%" },
      size: { width: 120, height: 108 },
      mobilePos: { bottom: "-22%", right: "-3%" },
      mobileSize: { width: 110, height: 95 },
      isMobileReverse: 6,
    },
  ];

  if (isMobile) {
    const tamper = features.find((f) => f.key === "tamper");
    features = features.filter((f) => f.key !== "tamper");
    features.splice(1, 0, tamper);
  }

  const handleClose = () => {
    setOpenFeature(null);
    setPausedFeature(null);
  };

  const handleNextStep = () => {
    setActiveStep((prev) => prev + 1);
    handleUpdate("LearnMore");
  };

  const handleOpen = (feature, ref) => {
    if (ref && ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const top = rect.top + window.scrollY + rect.height / 2;
      const left = isMobile
        ? "50%"
        : rect.left + window.scrollX + rect.width / 2 - 25;
      if (isMobile) {
        setTooltipPos({ top: top - 300, left });
      } else {
        setTooltipPos({ top: top + 140, left });
      }
    } else {
      setTooltipPos({
        top: window.innerHeight / 2 + window.scrollY,
        left: window.innerWidth / 2,
      });
    }
    setOpenFeature(feature);
  };
  //Previous Code Without local storage

  // const markReviewed = (featureKey) => {
  //   setReviewedFeatures((prev) =>
  //     prev.includes(featureKey) ? prev : [...prev, featureKey]
  //   );
  // };

  const markReviewed = (featureKey) => {
  setReviewedFeatures((prev) => {
    if (prev.includes(featureKey)) return prev;
    const updated = [...prev, featureKey];
    localStorage.setItem("reviewedFeatures", JSON.stringify(updated));
    return updated;
  });
};


  const handleFeatureClick = (feature) => {
    // const reviewed = reviewedFeatures.includes(feature.key);
    markReviewed(feature.key);

    if (isMobile) {
      // if (reviewed) {
        handleClose();
        setPausedFeature(null);
      //   return;
      // }

      if (openFeature?.key === feature.key) {
        handleClose();
        setPausedFeature(null);
      } else {
        handleOpen(feature, { current: iconRefs.current[feature.key] });
        setPausedFeature(feature.key);
      }
    }
  };

  const GlowingCard = ({ f, isMobile, paused, reviewed }) => {
    const borderRef = useRef(null);

    useEffect(() => {
      if (!isMobile || !borderRef.current || paused || reviewed) return;
      let angle = 0;
      let animationFrameId;
      const rotate = () => {
        if (!borderRef.current) return;
        angle = (angle + 1) % 360;
        borderRef.current.style.setProperty("--angle", `${angle}deg`);
        animationFrameId = requestAnimationFrame(rotate);
      };
      rotate();
      return () => cancelAnimationFrame(animationFrameId);
    }, [isMobile, paused, reviewed]);

    return (
      <div
        ref={borderRef}
        className={isMobile && !paused && !reviewed ? "rotating-border" : ""}
        style={{ borderRadius: "15px", display: "inline-block" }}
      >
        <Card
          sx={{
            ...(isMobile ? f.mobileSize : f.size),
            borderRadius: 3,
            border: "1px solid #ddd",
            boxShadow: 0,
            backgroundColor: "#f1f5f9",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            transition: "0.3s",
            "&:hover": reviewed ? {} : { transform: "scale(1.05)" },
          }}
        >
          <img
            src={f.img}
            alt={f.title}
            style={{ width: "90%", height: "90%", objectFit: "contain" }}
          />
        </Card>

        <style>
          {`
          .rotating-border {
            background:
              linear-gradient(#f1f5f9, #f1f5f9) padding-box,
              conic-gradient(
                from var(--angle, 0deg),
                transparent,
                #76bc21 10%,
                #a3e635 25%,
                #c0ff6f 40%,
                #76bc21 50%,
                transparent 60%
              ) border-box;
            border: 2px solid transparent;
            border-radius: 16px;
          }
        `}
        </style>
      </div>
    );
  };

  GlowingCard.propTypes = {
  isMobile: PropTypes.bool,
  paused: PropTypes.bool,
  reviewed: PropTypes.bool,
};

  return (
    <Box sx={{ textAlign: "center", width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "center",
          alignItems: isMobile ? "center" : "flex-start",
          flexWrap: isOpenCloseBtn?"wrap":"nowrap",
          gap: 5,
          mb: isMobile ? 8 : 4,
          paddingX: isMobile ? "10px" : "25px",
          mt: "25px",
        }}
      >
        <Box
          sx={{
            maxWidth: isMobile ? "100%" : 320,
            px: isMobile ? 1 : 2,
            py: isMobile ? 1 : 2,
            bgcolor: "white",
            borderRadius: 3,
            border: "1px solid #ddd",
            textAlign: "left",
          }}
        >
          <Typography variant="subtitle1" fontWeight={600} mb={1}>
            {t("speed.learnMoreMessage")}
          </Typography>
          <Grid
            sx={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr 1fr" : "1fr",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {features.map((feature, index) => {
              const reviewed = reviewedFeatures.includes(feature.key);
              return (
                <Typography
                  key={feature.key}
                  onMouseEnter={() => {
                    if (!isMobile) {
                      if (!reviewed) markReviewed(feature.key);
                      handleOpen(feature, { current: iconRefs.current[feature.key] });
                    }
                  }}

                  onMouseLeave={() => !isMobile && handleClose()}
                  onClick={() => {
                    if (!reviewedFeatures.includes(feature.key) && !isMobile) {
                      markReviewed(feature.key);
                      handleOpen(feature, {
                        current: iconRefs.current[feature.key],
                      });
                      setPausedFeature(feature.key);
                    }
                  }}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent:
                      index === features.length - 1 && isMobile ? "center" : "",
                    gap: 1,
                    mb: 1,
                    maxWidth: index === features.length - 1 && isMobile ? "100%": "max-content",
                    px: isMobile ? "" : 2,
                    cursor: "pointer",
                    fontSize: isMobile ? "14px" : "16px",
                    color: reviewed ? "#76bc21" : "#000",
                    // "&:hover": reviewed ? {} : { color: "primary.main" },
                    ...(index === features.length - 1
                      ? { gridColumn: "1 / -1" }
                      : {}),
                  }}
                >
                  <CheckIcon
                    fontSize="13px"
                    sx={{ color: reviewed ? "#76bc21" : "#000" }}
                  />
                  {feature.title}
                </Typography>
              );
            })}
          </Grid>
        </Box>

        <Box onMouseLeave={() => !isMobile && handleClose()}>
          {isMobile && (
            <Typography
              textTransform="uppercase"
              fontSize="12px"
              textAlign="center"
              color="#707070"
              fontWeight="500"
            >
              {t("speed.tapPicture")}
            </Typography>
          )}
          <Box
            sx={{
              position: "relative",
              width: isMobile ? 340 : isTablet ? 560 : 640,
              height: isMobile ? 360 : 500,
              marginTop: isMobile ? 10 : -1,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "47%",
                transform: "translate(-50%, -50%)",
                width: isMobile ? 280 : 368,
                height: isMobile ? 280 : 368,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={isMobile ? centerImgMobile : centerImg}
                alt="Device and Lines"
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            </Box>

            {features.map((f) => {
              const reviewed = reviewedFeatures.includes(f.key);
              return (
                <Box
                  key={f.key}
                  ref={(el) => (iconRefs.current[f.key] = el)}
                  sx={{
                    position: "absolute",
                    ...(isMobile ? f.mobilePos : f.position),
                    transform: "translate(-50%, -50%)",
                  }}
                  onClick={() => handleFeatureClick(f)}
                  onMouseEnter={() => {
                    if (!isMobile) {
                      if (!reviewed) markReviewed(f.key);
                        handleOpen(f, {
                          current: iconRefs.current[f.key],
                        });
                    }
                  }}
                >
                  <GlowingCard
                    f={f}
                    isMobile={isMobile}
                    paused={pausedFeature === f.key}
                    reviewed={reviewed}
                  />
                </Box>
              );
            })}
          </Box>

          {openFeature && (
            <CustomTooltip
              key={openFeature.key}
              title={openFeature.title}
              desc={openFeature.desc}
              open={true}
              imgSrc={openFeature.img}
              onClose={handleClose}
              isMobile={isMobile}
              isTablet={isOpenCloseBtn}
              pos={tooltipPos}
            />
          )}

          {!isMobile && (
            <Typography
              textTransform="uppercase"
              fontSize="12px"
              textAlign="center"
              color="#707070"
              fontWeight="500"
              mt={-2}
            >
              {t("speed.hoverPicture")}
            </Typography>
          )}
        </Box>
      </Box>
      <ContinueButton
        submitting={submitting}
        onClick={() => handleNextStep()}
        isLongWidth={true}
      />
    </Box>
  );
};

LearnMore.propTypes = {
  setActiveStep: PropTypes.func,
  submitting: PropTypes.bool,
  f: PropTypes.object,
  handleUpdate: PropTypes.func,
};

function mapStateToProps() {
  return {};
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LearnMore);
